/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ActiveStep/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Automation from './Automation/index'
import No from './No/index'
import Preferences from './Preferences/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ActiveStep({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection/SetupAutomations/Content/Content/Content/Steps/Content/ActiveStep"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let selectedStepTypeValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'step_type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: selectedStepTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Automation'}>
<Automation
  viewPath={`${viewPath}/Automation`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Preferences'}>
<Preferences
  viewPath={`${viewPath}/Preferences`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}